import { render, staticRenderFns } from "./DataExport.vue?vue&type=template&id=15064e39&scoped=true"
import script from "./DataExport.vue?vue&type=script&lang=js"
export * from "./DataExport.vue?vue&type=script&lang=js"
import style0 from "./DataExport.vue?vue&type=style&index=0&id=15064e39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15064e39",
  null
  
)

export default component.exports